import { render, staticRenderFns } from "./SuccessfulBiddersHeader.vue?vue&type=template&id=422d256c&"
import script from "./SuccessfulBiddersHeader.vue?vue&type=script&lang=js&"
export * from "./SuccessfulBiddersHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('422d256c')) {
      api.createRecord('422d256c', component.options)
    } else {
      api.reload('422d256c', component.options)
    }
    module.hot.accept("./SuccessfulBiddersHeader.vue?vue&type=template&id=422d256c&", function () {
      api.rerender('422d256c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/aduanas/successfulBidder/views/components/SuccessfulBiddersHeader.vue"
export default component.exports